function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(2.6667 0 0 2.6667 .0066663 -4e-7)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12 8a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.294 13.9-0.444-0.256a9.1 9.1 0 0 0 0-3.29l0.444-0.256a3.0017 3.0017 0 1 0-3-5.2l-0.445 0.257a8.977 8.977 0 0 0-2.849-1.642v-0.513a3 3 0 1 0-6 0v0.513a8.977 8.977 0 0 0-2.848 1.646l-0.452-0.259a3.0017 3.0017 0 1 0-3 5.2l0.444 0.256a9.1 9.1 0 0 0 0 3.29l-0.444 0.254a3.0017 3.0017 0 0 0 3 5.2l0.445-0.257a8.977 8.977 0 0 0 2.855 1.644v0.513a3 3 0 0 0 6 0v-0.513a8.977 8.977 0 0 0 2.848-1.646l0.447 0.258a3.0017 3.0017 0 1 0 3-5.2zm-2.548-3.776a7.048 7.048 0 0 1 0 3.75 1 1 0 0 0 0.464 1.133l1.084 0.626a1.0004 1.0004 0 1 1-1 1.733l-1.086-0.628a1 1 0 0 0-1.215 0.165 6.984 6.984 0 0 1-3.243 1.875 1 1 0 0 0-0.751 0.969v1.253a1 1 0 0 1-2 0v-1.252a1 1 0 0 0-0.751-0.969 6.984 6.984 0 0 1-3.242-1.879 1 1 0 0 0-1.215-0.165l-1.084 0.627a1 1 0 1 1-1-1.732l1.084-0.63a1 1 0 0 0 0.464-1.133 7.048 7.048 0 0 1 0-3.75 1 1 0 0 0-0.465-1.125l-1.084-0.626a1.0004 1.0004 0 0 1 1-1.733l1.086 0.628a1 1 0 0 0 1.214-0.161 6.984 6.984 0 0 1 3.243-1.875 1 1 0 0 0 0.751-0.973v-1.252a1 1 0 0 1 2 0v1.252a1 1 0 0 0 0.751 0.969 6.984 6.984 0 0 1 3.243 1.879 1 1 0 0 0 1.215 0.165l1.084-0.627a1 1 0 1 1 1 1.732l-1.084 0.63a1 1 0 0 0-0.463 1.129z"
}));
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.8381bffe.svg";
export { ForwardRef as ReactComponent };